import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CalculoCartaCreditoVO } from '../shared/model/calculo-carta-credito-vo.model';
import { ParametroCartaCredito } from '../shared/model/parametro-carta-credito.model';
import { TipoProdutoEnum } from '../shared/enum/tipo-produto.enum';
import { CartaCreditoForm } from '../carta-credito-shared/form/carta-credito.form';


@Injectable({
  providedIn: 'root'
})
export class CalculoCartaCreditoTrimestralService {

  private calculoCarta: CalculoCartaCreditoVO;
  isEmpresaPadis: boolean = false;

  constructor() {
    this.calculoCarta = new CalculoCartaCreditoVO();
  }

  calcularValorCredito(cartaForm: CartaCreditoForm, parametro: ParametroCartaCredito) {

    if (this.isEmpresaPadis) {
      this.obterCalculosCartaCredito(cartaForm.padis, parametro.multiplicadorPadis,
      parametro.percentualPadis, cartaForm.excedente, TipoProdutoEnum.NORMAL);
    } else {

      this.obterCalculosCartaCredito(
        cartaForm.sudanSudene, parametro.multiplicadorSudanSudeneCentroOeste,
        parametro.percentualSudanSudeneCentroOeste, cartaForm.excedente, TipoProdutoEnum.NORMAL
      );

      this.obterCalculosCartaCredito(
        cartaForm.sudanSudeneTecnac, parametro.multiplicadorSudanSudeneCentroOesteTecnac,
        parametro.percentualSudanSudeneCentroOesteTecnac, cartaForm.excedente, TipoProdutoEnum.TECNAC
      )

      this.obterCalculosCartaCredito(
        cartaForm.demaisRegioes, parametro.multiplicadorDemaisRegioes,
        parametro.percentualDemaisRegioes, cartaForm.excedente, TipoProdutoEnum.NORMAL
      )

      this.obterCalculosCartaCredito(
        cartaForm.demaisRegioesTecnac, parametro.multiplicadorDemaisRegioesTecnac,
        parametro.percentualDemaisRegioesTecnac, cartaForm.excedente, TipoProdutoEnum.TECNAC
      )
    }
  }

  obterCalculosCartaCredito(formRegiao: FormGroup,
    multiplicador: number,
    percentual: number,
    acumulado: FormGroup,
    tipoProduto: TipoProdutoEnum) {

    this.calculoCarta.valorCredito = 0;
    const valorInvestimentoPdi = formRegiao.get('investimentoPDI')
      .get('valor').value;

    const faturamentoProduto = formRegiao.get('faturamentoTotalProduto')
      .get('valor').value

    if (faturamentoProduto !== null) {

      this.iniciarValoresCartaCredito(valorInvestimentoPdi, multiplicador, faturamentoProduto, percentual);
      this.calculoCarta = this.calcularValores(this.calculoCarta);
      formRegiao.get('valorPDIRemanescenteTemp').get('valor').patchValue(
        this.calculoCarta.valorRemanescente);

      this.iniciarValoresCartaCredito(valorInvestimentoPdi, multiplicador, faturamentoProduto, percentual);
      this.verificarValoresAcumuladoUtilizados(tipoProduto, acumulado);
      this.calculoCarta = this.calcularValores(this.calculoCarta);
      this.definirValoresFormularios(formRegiao);
    } else {
        this.resetarValores(formRegiao, faturamentoProduto);
        if(this.isEmpresaPadis) {
          this.verificarValoresAcumuladoUtilizados(tipoProduto, acumulado);
        }
        this.definirValoresFormularios(formRegiao);
    }
    if(this.isEmpresaPadis) {
      acumulado.get('valorExcedenteUtilizado').updateValueAndValidity();
    }
  }

  iniciarValoresCartaCredito(valorInvestimentoPdi: number,
    multiplicador: number,faturamentoProduto: number, percentual: number  ) {

    this.calculoCarta.valorCredito = 0;
    if (valorInvestimentoPdi) {
      this.calculoCarta.valorCredito += valorInvestimentoPdi * multiplicador;
    }
    this.calculoCarta.valorLimiteCredito = (faturamentoProduto * percentual / 100);
    this.calculoCarta.valorExcedente = 0;
    this.calculoCarta.valorExcedenteAcumulado = 0;
    this.calculoCarta.valorRemanescente = 0;
    this.calculoCarta.valorExcendenteUtilizado = 0;
    this.calculoCarta.valorExcedenteUtilizadoTecnac = 0;
    this.calculoCarta.valorRemanescenteAcumulado = 0;
    this.calculoCarta.valorRemanescenteUtilizado = 0;
    this.calculoCarta.valorRemanescenteTecnac = 0;
  }

  inicializarValoresCalculo() {
    this.calculoCarta.valorRemanescente = 0;
    this.calculoCarta.valorRemanescenteAcumulado = 0
  }

  verificarValoresAcumuladoUtilizados(tipoProduto: TipoProdutoEnum,
    acumulado: FormGroup) {
    this.verificarExcedenteAcumuladoUtilizado(tipoProduto, acumulado);
    this.verificarRemanescenteAcumuladoUtilizado(tipoProduto, acumulado);

  }

  verificarExcedenteAcumuladoUtilizado(tipoProduto: TipoProdutoEnum,
    acumulado: FormGroup) {
    const valorExcedenteUtilizadoNormal = acumulado.get('valorExcedenteUtilizado')
      .get('valor').value;
    const valorExcedenteUtilizadoTecnac = acumulado.get('valorExcedenteUtilizadoTecnac')
      .get('valor').value;

    if (tipoProduto === TipoProdutoEnum.TECNAC && valorExcedenteUtilizadoTecnac) {
      this.calculoCarta.valorCredito += valorExcedenteUtilizadoTecnac
    }

    if (tipoProduto === TipoProdutoEnum.NORMAL && valorExcedenteUtilizadoNormal) {
      this.calculoCarta.valorCredito += valorExcedenteUtilizadoNormal;
    }

  }

  verificarRemanescenteAcumuladoUtilizado(tipoProduto: TipoProdutoEnum,
    acumulado: FormGroup) {
    const valorRemanescenteUtilizadoNormal = acumulado.get('valorRemanescenteUtilizado')
      .get('valor').value;
    const valorRemanescenteUtilizadoTecnac = acumulado.get('valorRemanescenteUtilizadoTecnac')
      .get('valor').value;

    if (tipoProduto === TipoProdutoEnum.TECNAC && valorRemanescenteUtilizadoTecnac) {
      this.calculoCarta.valorLimiteCredito += valorRemanescenteUtilizadoTecnac
      return;
    }
    if (tipoProduto === TipoProdutoEnum.NORMAL && valorRemanescenteUtilizadoNormal) {
      this.calculoCarta.valorLimiteCredito += valorRemanescenteUtilizadoNormal;
    }
  }

  calcularValores(calculoCarta: CalculoCartaCreditoVO) {

    let valorCalculado = calculoCarta.valorCredito - calculoCarta.valorLimiteCredito

    if (valorCalculado > 0) {
      calculoCarta.valorExcedente = valorCalculado;
      calculoCarta.valorExcedenteAcumuladoCalculado = calculoCarta.valorExcedenteAcumulado + calculoCarta.valorExcedente;

      calculoCarta.valorCredito = calculoCarta.valorLimiteCredito;
    } else {
      calculoCarta.valorExcedenteAcumuladoCalculado = calculoCarta.valorExcedenteAcumulado + calculoCarta.valorExcedente
      if (calculoCarta.valorExcedenteAcumulado > 0) {
        calculoCarta.valorCredito = calculoCarta.valorCredito + calculoCarta.valorExcedenteAcumulado;
        calculoCarta.valorExcedenteAcumulado = 0;

        this.calcularValores(calculoCarta);
      }

      this.calculoCarta.valorRemanescente = Math.abs(valorCalculado);

    }
    return calculoCarta;
  }

  definirValoresFormularios(formRegiao: FormGroup) {
    formRegiao.get('valorCredito').get('valor').patchValue(this.calculoCarta.valorCredito);
    formRegiao.get('limiteCredito').get('valor').patchValue(this.calculoCarta.valorLimiteCredito);
    formRegiao.get('valorPDIExcedente').get('valor').patchValue(this.calculoCarta.valorExcedente);
    formRegiao.get('valorPDIRemanescente').get('valor').patchValue(
      this.calculoCarta.valorRemanescente);
  }

  resetarValores(formRegiao: FormGroup, faturamentoProduto: number) {
    formRegiao.get('valorCredito').get('valor').setValue(0);
    this.calculoCarta.valorCredito = 0;
    formRegiao.get('valorPDIExcedente').get('valor').setValue(0);
    this.calculoCarta.valorExcedente = 0;
    formRegiao.get('valorPDIRemanescente').get('valor').setValue(0);
    this.calculoCarta.valorRemanescente = 0;
    formRegiao.get('valorPDIRemanescenteTemp').get('valor').setValue(0);
    this.calculoCarta.valorRemanescente = 0;
    if(!faturamentoProduto) {
      this.calculoCarta.valorLimiteCredito = 0;
      formRegiao.get('limiteCredito').get('valor').setValue(0);
    }
  }

  obterValorLimiteCredito(formGroup: FormGroup, percentual: number) {
    this.calculoCarta.valorLimiteCredito = (formGroup.get('faturamentoTotalProduto')
      .get('valor').value * percentual / 100);
    formGroup.get('limiteCredito').get('valor').patchValue(this.calculoCarta.valorLimiteCredito);
  }

}
